<div class="w-fit ml-auto" *ngIf="currentInputToShow"> 
  <stdout-button (click)="editCurrentElement()" class="btn-blu md:w-[408px] md:h-[52px] mb-5 mr-2 mobile"
                size="large"
                color="white" >Salva modifiche</stdout-button>
</div>
<div class="w-full h-full flex items-stretch scroll" *ngIf="data.length > 0">
  <!-- prima tab -->
  <div class="w-1/10 h-full head-check flex flex-col" *ngIf="showCheck">
    <table class="min-w-full table-auto flex-grow">
      <thead>
        <tr #tableHeader>
          <th class="px-[14px] py-[16px] sopratab max-w-[58px] max-h-[58px]">
            <div class="w-full h-full flex items-center justify-center  cursor-pointer">
              <stdout-checkbox [checked]="(check$ | async) || false"
                (change)="onCheckboxChangeAll($event)"></stdout-checkbox>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr class="w-full h-[10px] !bg-[#FCFAFA]"></tr>
      </tbody>
      <div class="corpo-check">
        <tbody>
          <tr *ngFor="let row of dataView; let rowIndex = index" class="h-[105px]">
            <td #myDiv class="px-[14px] py-[16px] check-header-fix check-corpo cursor-pointer h-[105px]"
              [style.height.px]="maxHeight">
              <div class="w-full h-full flex items-center justify-center"
                [ngClass]="{ 'check-corpo-te': perTe.includes(row.id) }">
                <stdout-checkbox [checked]="row.selected" (change)="onCheckboxChange(row, $event)"
                  [id]="row.id"></stdout-checkbox>
              </div>
            </td>
          </tr>
        </tbody>
      </div>
    </table>
  </div>
  <!-- seconda tabella -->
  <div class="w-full h-full ml-[10px] head-dati corpo-dati flex flex-col"
    [ngClass]="{ 'scrollable-table overflow-x-auto ': isScrollable }"
    (mousedown)="isScrollable ? startDragging($event, scrollableDiv) : null"
    (mouseup)="isScrollable ? stopDragging() : null" (mouseleave)="isScrollable ? stopDragging() : null"
    (mousemove)="isScrollable ? moveEvent($event, scrollableDiv) : null" #scrollableDiv>
    <table class="min-w-full table-auto flex-grow overflow-hidden">
      <thead>
        <tr #tableHeader2>
          <th scope="col" #tabHead class="px-[14px] py-[16px] whitespace-nowrap text-center uppercase tracking-wider"
            *ngFor="let column of columns">
            <p [class]="tabText"> {{ column.display }}</p>
          </th>
          <!-- <th scope="col" #tabHead class="px-[14px] py-[16px] whitespace-nowrap text-center uppercase tracking-wider"
            >
            <p [class]="tabText">SCADENZA</p>
          </th> -->
        </tr>
      </thead>

      <tbody>
        <tr class="w-full h-[10px] !bg-[#FCFAFA]"></tr>
      </tbody>

      <tbody>
        <tr class="!h-[105px]" *ngFor="let row of dataView; let rowIndex = index" [ngClass]="{
            highlight: changeId.includes(row.id),
            perTeDati: perTe.includes(row.id)
          }" >
          <td [title]="row[column.dataIndex]" #myDiv class="px-[14px] py-[16px] !h-[105px] text-center  cursor-pointer" 
            *ngFor="let column of columns; let isFirst = first" (dblclick)="clicca(row)"
            (touchend)="handleTap($event, row)">
            <div [title]="row[column.dataIndex]" class="flex items-center justify-center">
              <p [class]="tabText" *ngIf="column.dataIndex !== 'cover' && column.dataIndex !== 'ordinePerTe' &&  column.dataIndex !== 'scadenzaPerTe'" class="w-full limited-text whitespace-nowrap overflow-hidden text-ellipsis max-w-[250px]" >
                {{ row[column.dataIndex] }}
              </p>
              <img class="w-[30px]" *ngIf="column.dataIndex === 'cover' && row[column.dataIndex]"
                [src]="'../../assets/'+row[column.dataIndex]" />
              <p *ngIf="column.dataIndex === 'cover' && !row[column.dataIndex]" class="w-full h-full">
                -
              </p>
              <div *ngIf="column.dataIndex === 'ordinePerTe'" class="cursor-pointer w-full" (click)="newPerTeOrder = row[column.dataIndex];currentInputToShow = row[column.dataIndex] + rowIndex;currentRowInEdit = row">
                <div *ngIf="currentInputToShow !== (row[column.dataIndex] + rowIndex)">{{ row[column.dataIndex] }}</div>
                <div *ngIf="currentInputToShow === (row[column.dataIndex] + rowIndex)"><stdout-text-input type="number" class="search-bar" placeholder="Posizionamento" [(ngModel)]="newPerTeOrder" ></stdout-text-input></div>
              </div>
              <div *ngIf="column.dataIndex === 'scadenzaPerTe'" class="cursor-pointer w-full" (click)="newScadenzaPerte = row[column.dataIndex];currentInputToShow = row[column.dataIndex] + rowIndex;currentRowInEdit = row">
                <div *ngIf="currentInputToShow !== (row[column.dataIndex] + rowIndex)">{{ row[column.dataIndex] }}</div>
                <div *ngIf="currentInputToShow === (row[column.dataIndex] + rowIndex)"><stdout-text-input type="date" class="search-bar" placeholder="Scadenza" [(ngModel)]="newScadenzaPerte" ></stdout-text-input></div>
              </div>
            </div>
          </td>
          <!-- <td [title]="'Scadenza'" #myDiv class="px-[14px] py-[16px] !h-[105px] text-center  cursor-pointer" 
           (dblclick)="clicca(row)"
            (touchend)="handleTap($event, row)">
            <div [title]="'Scadenza'" class="flex items-center justify-center">
              <p [class]="tabText" class="w-full limited-text whitespace-nowrap overflow-hidden text-ellipsis max-w-[250px]" >
               {{row}}
              </p>
              
            </div>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="flex items-center place-content-center text-[32px] mt-4" *ngIf="data.length==0">NESSUN RISULTATO TROVATO</div>